import React, { useState, useEffect, useContext } from "react";
import "./ContactUsForm.css";
import URLstateContext from "../../../../provider/CommonContext";
import {
    GetPostMethodData,
    DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import { Col, Container, Row } from "react-bootstrap";
import Button from "@mui/material/Button";

function ContactUsForm() {
    const [data, setData] = useState([]);
    const [isCityShown, setIsCityShown] = useState(false);
    const [valueEmail, setValueEmail] = useState('');
    const [emailError, setEmailError] = useState('');
    const [valueName, setValueName] = useState('');
    const [nameError, setNameError] = useState('');
    const [valueMob, setValueMob] = useState('');
    const [mobError, setMobError] = useState('');
    const [valueCity, setValueCity] = useState('');
    const [cityError, setCityError] = useState('');
    const [valueComments, setValueComments] = useState('');
    const { BaseURL } = useContext(URLstateContext);
    const [valueState, setValueState] = useState([]);
    const [stateError, setStateError] = useState('');
    const [pathname, setPathName] = useState('');

    useEffect(() => {
        const pathname = window.location.pathname.replace("-", " ");
        const lastSegment = pathname.slice(pathname.lastIndexOf('/') + 1);
        const CategoryIdUrlid = lastSegment;
        setPathName(CategoryIdUrlid);
    },[])

    useEffect(() => {
        GetPostMethodData(BaseURL + "GetCityState", {
            IVcity: valueCity,
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                // console.log(DecryptAESdata(data.data))
            }
        });
    }, [BaseURL, valueCity]);

    const handleName = event => {
        let regex = /^[A-Za-z\s]*$/;
        if (regex.test(event.target.value)) {
            setValueName(event.target.value);
        }
        if (event.target.value.length === 0) {
            setValueName("");
        }
        setNameError("");
    };
    const handleEmail = event => {
        setValueEmail(event.target.value);
        setEmailError("");
    };
    const handleMobile = event => {
        const reMob = /^[0-9\b]+$/;
        if (reMob.test(event.target.value)) {
            setValueMob(event.target.value);
        }
        if (event.target.value.length === 0) {
            setValueMob("");
        }
        setMobError("");
    };
    const handleCity = event => {
        setValueCity(event.target.value);
        // setValue(event.target.value);
        setCityError("");
        if (event.target.value !== "") {
            setIsCityShown(true);
        } else {
            setIsCityShown(false);
        }
    };
    const handleState = event => {
        setValueState(event.target.value);
        setStateError("");
    };

    const submitContactForm = () => {
        let regrex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let nameflag = true; 
        let emailflag = true; 
        let mobileflag = true; 
        let emailvalidflag = true; 
        let cityflag = true; 
        let stateFlag = true;
        if (valueEmail == "") {
            setEmailError("Please Enter Email Address");
            emailflag = false;
            return false;
        }
        if (!regrex.test(valueEmail)) {
            setEmailError("Please Enter valid email address");
            emailvalidflag = false;
            return false;
        }
        if (valueName == "") {
            nameflag = false;
            setNameError("Please Enter Your Name");
            return false;
        }
        if (valueMob == "") {
            setMobError("Please Enter Mobile Number");
            mobileflag = false;
            return false;
        }
        if (valueMob.length != 10) {
            setMobError("Please Enter Valid Mobile number");
            mobileflag = false;
            return false;
        }
        if (valueCity == "") {
            cityflag = false;
            setCityError("Please Select City");
            return false;
        }
        if (valueState == "") {
            stateFlag = false;
            setStateError("Please Select State");
            return false;
        }
        GetPostMethodData(BaseURL + "GetContactUs", {
            IVemailid: valueEmail,
            IVname: valueName,
            IVmobile: valueMob,
            IVcity: valueCity,
            IVstate: valueState,
            IVquery: valueComments,
        }).then((data) => {
            if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
                alert("Your form is successfully submitted !!!")
            }
        });
        setValueEmail(""); setValueName(""); setValueMob(""); setValueComments("");
        document.getElementById("select-City").selectedIndex = "0";
        document.getElementById("select-State").selectedIndex = "0";
    }
    const resetForm = () => {
        setValueEmail(""); setValueName(""); setValueMob(""); setValueComments("");
        document.getElementById("select-City").selectedIndex = "0";
        document.getElementById("select-State").selectedIndex = "0";
    }
    return (
        <>

            <Container>


                <Row>
                    <div className='distributer-h1 tab-wrapper'>
                        <ul className="navigator-arrow">
                            <li><a><i class="fa fa-home" aria-hidden="true"></i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                            <li><a><i>CustomerServices</i></a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>

                            {window.location.pathname != "/CustomerServices" ? <li>{pathname.replace("-", " ")}</li> : ''}
                        </ul>
                        <h1 className='header-sc'>Contact Us</h1>
                    </div>
                    <h5 class="text-center"> Please enter the following to help you better </h5>
                    <Col sm={12} md={6} className="input-type-box">
                        <label> Email<span>*</span> </label>
                        <input type="text" placeholder="Enter Email ID" value={valueEmail} onChange={handleEmail} maxLength="50" />
                        <span>{emailError != '' && <div className="errorMsg">{emailError}</div>}</span>
                    </Col>
                    <Col sm={12} md={6} className="input-type-box">
                        <label> Name<span>*</span> </label>
                        <input type="text" placeholder="Enter Your Name" value={valueName} onChange={handleName} maxLength="50" />
                        <span>{nameError != '' && <div className="errorMsg">{nameError}</div>}</span>
                    </Col>
                    <Col sm={12} md={6} className="input-type-box">
                        <label> Mobile No<span>*</span> </label>
                        <input type="text" placeholder="Enter Mobile No" value={valueMob} maxLength="10" onChange={handleMobile} />
                        <span>{mobError != '' && <div className="errorMsg">{mobError}</div>}</span>
                    </Col>
                    <Col sm={12} md={6} className="input-type-box">
                        <label> City<span>*</span> </label>
                        <select onChange={handleCity} id="select-City">
                            {data && data.length > 0 ? (
                                <>
                                    <option value=""> Select City </option>
                                    {/* {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''} */}
                                    {data &&
                                        data.map(
                                            ({ cityname }) => (
                                                <option value={cityname} selected={valueCity === cityname}> {cityname} </option>
                                            )
                                        )}
                                </>
                            ) : (
                                <h5 className="errormsgComNew">No Data Found !!!</h5>
                            )}
                        </select>
                        <span>{cityError != '' && <div className="errorMsg">{cityError}</div>}</span>
                    </Col>
                    <Col sm={12} md={6} className="input-type-box">
                        <label> State<span>*</span> </label>
                        <select onChange={handleState} id="select-State">
                            {data && data.length > 0 ? (
                                <>
                                    <option value=""> Select State</option>
                                    {isCityShown &&
                                        data.map(
                                            ({ statename }) => (
                                                <option value={statename}> {statename} </option>
                                            )
                                        )}
                                </>
                            ) : (
                                <h5 className="errormsgComNew">No Data Found !!!</h5>
                            )}
                        </select>
                        <span>{stateError != '' && <div className="errorMsg">{stateError}</div>}</span>
                    </Col>
                    <Col sm={12} className="input-type-box">
                        <label> Your Comments / Query </label>
                        <textarea value={valueComments} onChange={(event) => setValueComments(event.target.value)} maxLength="1000"> Type here</textarea>
                    </Col>
                    <div class="sticky-icon">

                        <div id="fixed-social">

                            <div>
                                <a class="fixed-instagrem" target="_blank"><i class="fa fa-phone-square" style={{color : "#fff"}}></i> <span>1800 1038 345</span></a>
                            </div>
                            <div>
                                <a class="fixed-tumblr" target="_blank" href="mailto:" style={{color : "#000"}} className="hover-contact"><i class="fa fa-envelope"></i> <span>investor@jmfl.com</span><br></br><span>partnercare@jmfl.com</span></a>
                            </div>
                        </div>
                    </div>
                </Row>
                <div className="btn-container Contact">
                    <Button variant="contained" onClick={submitContactForm} aria-label="submit-button">Submit</Button>
                    <Button variant="contained" onClick={resetForm} aria-label="reset-button">Reset</Button>
                </div>
            </Container>
        </>
    )
}

export default ContactUsForm